import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { Box, Grid, Card, CardContent, Typography, List, ListItem, Button } from '@material-ui/core';
import { useHistory } from "react-router-dom";
import ScrollToTopOnMount from '../components/ScrollToTopOnMount'
import UpdatePage from '../components/UpdatePage'
import ServiceCard from '../components/ServiceCard'
import LazyImg from '../components/LazyImg'

import mainImg_desktop from '../images/mainImg.jpg'
import audits_400 from '../images/audits_small.jpg'
import audits_750 from '../images/audits_med.jpg'
import audits_1250 from '../images/audits_large.jpg'
import investigative_400 from '../images/investigative_small.jpg'
import investigative_750 from '../images/investigative_med.jpg'
import investigative_1250 from '../images/investigative_large.jpg'
import process_400 from '../images/process_small.jpg'
import process_750 from '../images/process_med.jpg'
import process_1250 from '../images/process_large.jpg'
import regulatory_400 from '../images/regulatory_small.jpg'
import regulatory_750 from '../images/regulatory_med.jpg'
import regulatory_1250 from '../images/regulatory_large.jpg'

import mainImg_ph from '../images/mainImg_ph.jpg'
import audits_ph from '../images/audits_ph.jpg'
import investigative_ph from '../images/investigative_ph.jpg'
import process_ph from '../images/process_ph.jpg'
import regulatory_ph from '../images/regulatory_ph.jpg'

const useStyles = makeStyles((theme) => ({
    cardRoot: {
        width: "100%"
    },
    mediaCard: {
        width: "100%",
        position: 'relative',
        [theme.breakpoints.up('md')]: {
            height: '100%'
        }
    },
    imageGrad: {
        position: "absolute",
        height: '100%',
        width: '100%',
        top: 0,
        background: 'linear-gradient(to bottom, transparent, transparent, #0000009e)',
    },
    textOverlay: {
        position: "absolute",
        textShadow: '1px 1px 1px #000',
        color: '#fff',
        left: 0,
        bottom: theme.spacing(3),
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
        [theme.breakpoints.only('xs')]: {
            bottom: theme.spacing(2),
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
        },
    },
    mainMedia: {
        height: '100%',
        '& div': {
            height: 0,
            [theme.breakpoints.down('sm')]: {
                paddingBottom: '60%',
            },
            [theme.breakpoints.only('sm')]: {
                paddingBottom: '40%',
            },
            [theme.breakpoints.up('md')]: {
                height: '100%',
            }
        },
    },
    serviceMedia: {
        height: 0,
        paddingTop: '50%'
    }
}))

export default function Home() {
    const classes = useStyles();
    let history = useHistory();

    return (
        <Grid container spacing={2}>
            <ScrollToTopOnMount/>
            <UpdatePage title="RQuaL Solutions - Quality Compliance & Regulatory Consulting Firm" />
            <Grid item xs={12} md={7} lg={8}>
                <Card className={classes.mediaCard}>
                    <div className={classes.mainMedia}>
                        <LazyImg placeholder={mainImg_ph} srcSet={mainImg_desktop} /> 
                    </div>
                    <div className={classes.imageGrad}></div>
                    <Box className={classes.textOverlay} 
                        fontSize={{xs: 'h6.fontSize', sm: 'h5.fontSize'}}
                        lineHeight={1.33}
                    >
                        <b>R</b>egulatory & <b>Qua</b>lity <b>L</b>eadership (<b>RQuaL</b>) Solutions
                    </Box>
                </Card>
            </Grid>
            <Grid item xs={12} md={5} lg={4}>
                <Card className={classes.cardRoot}>
                    <CardContent>
                        <Typography gutterBottom variant="h6" component="h3">
                            Our Mission
                        </Typography>
                        <Typography align='justify' paragraph={true}>
                            RQuaL strives to be a Leading Quality Compliance &amp; Regulatory Consulting firm. It provides innovative and customized solutions for Pharmaceutical industry, so as to ensure safe and reliable access to life-saving medical products for the people in need.
                        </Typography>
                        <Typography gutterBottom variant="h6" component="h3">
                            Our Vision
                        </Typography>
                        <Typography align='justify' >
                            We aim to be a Partner of choice in Healthcare Industry and provide end to end Customized Solutions to Complex Matters related for Quality, cGMP Compliance and Regulatory Matters.
                        </Typography>
                    </CardContent>
                </Card>
            </Grid>
            <Grid item xs={12}>
                <Box fontSize="h5.fontSize" mt={{ xs: 2, md: 3 }}>
                    Our Services
                </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
                <ServiceCard heading="Audits" ph={audits_ph} 
                    src={[audits_400, audits_750, audits_1250]} link="#audits">
                    <List disablePadding={true} dense={true}>
                        <ListItem disableGutters>1. Site Due Diligence</ListItem>
                        <ListItem disableGutters>2. Initial Facility Designing</ListItem>
                        <ListItem disableGutters>3. Improvements in Facility Design</ListItem>
                        <ListItem disableGutters>4. HVAC Systems</ListItem>
                        <ListItem disableGutters>5. Water Systems</ListItem>
                        <ListItem disableGutters>6. Equipment Selection/Optimization</ListItem>
                        <ListItem disableGutters>7. Qualifications and Validations</ListItem>
                        <ListItem disableGutters>8. Vendor Audits and Qualification</ListItem>
                        <ListItem disableGutters>9. Vendor Evaluation</ListItem>
                    </List>
                </ServiceCard>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
                <ServiceCard heading="Investigative Activities" ph={investigative_ph}
                    src={[investigative_400, investigative_750, investigative_1250]} link="#investigative">
                    <List disablePadding={true} dense={true}>
                        <ListItem disableGutters>1. Documentation, DI Review</ListItem>
                        <ListItem disableGutters>2. Troubleshooting & Risk Analysis</ListItem>
                        <ListItem disableGutters>3. Investigations and RCA</ListItem>
                        <ListItem disableGutters>4. CAPA Management</ListItem>
                        <ListItem disableGutters>5. Quality Risk Management</ListItem>
                        <ListItem disableGutters>6. Preparing Internal Auditors</ListItem>
                        <ListItem disableGutters>7. GxP System Improvements</ListItem>
                    </List>
                </ServiceCard>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
                <ServiceCard heading="Process Optimisation" ph={process_ph}
                    src={[process_400, process_750, process_1250]} link="#process">
                    <List disablePadding={true} dense={true}>
                        <ListItem disableGutters>1. cGMP Automation Software</ListItem>
                        <ListItem disableGutters>2. Training Process Setup</ListItem>
                        <ListItem disableGutters>3. Specialized Subject Training</ListItem>
                        <ListItem disableGutters>4. Aseptic Processing Compliance</ListItem>
                        <ListItem disableGutters>5. Sterilizations</ListItem>
                        <ListItem disableGutters>6. Advanced Manufacturing</ListItem>
                        <ListItem disableGutters>7. Operation Excellence / PAT</ListItem>
                        <ListItem disableGutters>8. Analytical technology</ListItem>
                        <ListItem disableGutters>9. Analytical Services Optimization</ListItem>
                        <ListItem disableGutters>10. Technology Transfer</ListItem>
                    </List>
                </ServiceCard>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
                <ServiceCard heading="Regulatory Support" ph={regulatory_ph}
                    src={[regulatory_400, regulatory_750, regulatory_1250]} link="#regulatory">
                    <List disablePadding={true} dense={true}>
                        <ListItem disableGutters>1. Regulatory Filing</ListItem>
                        <ListItem disableGutters>2. Maintenance and Responses</ListItem>
                        <ListItem disableGutters>3. Regulatory Compliance</ListItem>
                        <ListItem disableGutters>4. Pre-Inspection Audit</ListItem>
                        <ListItem disableGutters>5. Regulatory Audit Preparedness</ListItem>
                        <ListItem disableGutters>6. Site Readiness</ListItem>
                        <ListItem disableGutters>7. Team Building - SMEs</ListItem>
                    </List>
                </ServiceCard>
            </Grid>
            <Grid item xs={12}>
                <Box fontSize="h6.fontSize" mt={{ xs: 2, md: 3 }} mb={{ xs: 1, md: 2 }}>
                    Why Choose RQuaL Solutions?
                </Box>
                <Typography align='justify' paragraph={true}>
                    RQuaL believes in providing wholesome solutions to our valued clients and puts all efforts in building long lasting relationships. 
                    We don’t just advise on how to achieve a successful outcome but promise to work alongside the <b>Ground Team</b> to get the Project accomplished in a <b>time bound manner</b>. 
                    <Button size="small" onClick={(e) => {e.preventDefault(); history.push('/services')}}>Learn More about our Services.</Button>
                </Typography>
            </Grid>
        </Grid >
    )
}